'use client';

import { cn } from '@/app/_shared/utils/tw-cn';
import { BrandSwipeItem } from '@/app/_components/widgets/brand-swipe/ui/brand-swipe-item';
import { useBrandSwipeProps } from '@/app/_components/widgets/brand-swipe/ui/brand-swipe-list/brand-swipe-list.context';

export const BrandSwipeListLoader = () => {
  const { items } = useBrandSwipeProps();
  return (
    <section className={cn('flex w-full justify-center pc:w-pc-size')}>
      <div className="flex w-full justify-center">
        {items.map((item, index) => (
          <div
            key={`${item.label}-${index.toString()}`}
            className={cn(
              '!w-fit',
              // slidesOffsetBefore, slidesOffsetAfter 옵션을 사용하면 ssr에서 렌더링이 깨지므로 margin으로 대체
              'first:ml-[16px] last:mr-[16px] pc:first:ml-[32px] pc:last:mr-[32px]',
              // spaceBetween 옵션을 사용하면 ssr에서 렌더링이 깨지므로 padding-right로 대체, 마지막 요소는 padding-right를 0으로 처리
              'pr-[12px] last:pr-0 pc:pr-[24px]',
            )}>
            <BrandSwipeItem
              item={item}
              onItemClick={() => {
                /***/
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
};
